export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13910.19c8d245.jpg";